export default "__VITE_ASSET__q3HrWqZC__"